// Function loadRenewalForm loads the RenewalForm class by dynamically importing the js on demand if needed

export function loadRenewalForm($parentEl, isList = false) {

	let $wg = $parentEl.querySelector('[data-wg="RenewalForm"]');

	if(!$wg) {
		// console.info('RenewalForm: no widget found');
		return Promise.reject('RenewalForm widget not found in the parent element');
	}

	return import(/* webpackChunkName: "wg-renewal-form-chunk" */ '../widgets/renewalForm').then(wg => {

		const { RenewalForm } = wg;

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="RenewalForm"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new RenewalForm($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new RenewalForm($wg);
		}


	}).catch(error => error+'An error occurred while loading the RenewalForm widget');

}
